import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AsyncLocalStorage} from './async-local-storage';
import {AsyncSessionStorage} from './async-session-storage';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AsyncLocalStorage, AsyncSessionStorage],
})
export class AsyncStorageModule {}
